module.exports = __webpack_public_path__ + "static/media/reportIcon.1ff1e1ea.png";